import { useNavigate } from 'react-router-dom';
import { LOGIN, REGISTER } from '../../routes/app/paths';
import PropTypes from 'prop-types';
import SocialLogin from '../Common/SocialLogin';
import CustomButton from '../Common/CustomButton';

function Login({ onClose, pr }) {
  /* Hooks */
  const navigate = useNavigate();

  /* Functions */
  const handleLoginEmail = () => {
    navigate(LOGIN);
    onClose(false);
  }

  const handleGoToRegister = () => {
    navigate(pr ? `${REGISTER}?pr=${pr}` : REGISTER);
    onClose(false);
  }
  
  return (
    <div className="p-4 select-none">
      <div className="mt-2 mx-auto">
        <div className="p-4 space-x-4 mx-auto">
          <p className="font-bold text-3xl text-center">
            Iniciar sesión
          </p>
        </div>
        <div>
          <CustomButton
            onClick={handleLoginEmail}
            className="px-6 py-2 rounded-full block w-full text-lg text-white font-semibold"
            primary
            text="Iniciar sesión con mi correo"
          />
          
          <div className="border-2 border-t my-6" />
          
          <SocialLogin onClose={onClose} />

          <p className="text-xs md:text-sm text-center mt-4 font-semibold">
            ¿Eres nuevo/a?{' '}
            <span
              className="font-bold cursor-pointer hover:text-bubble-gum"
              onClick={handleGoToRegister}
            >
              Regístrate aquí {'>'}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

Login.propTypes = {
  onClose: PropTypes.func.isRequired,
  pr: PropTypes.string,
};

export default Login;